import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  eyes: {
    cursor: 'pointer',
    margin: '0px 2px 0px 0px',
    width: '35px',
    height: '35px',
  },
}))

export default useStyles
